import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from 'shared/services';
import { unsubscribeFromAll } from '../util/unsubscribeFromAll';
import { Subscription } from 'rxjs';
import { PermissionObject } from '../interfaces/permissions.interface';
import { CurrentSupplierUserInterface } from '../interfaces/current-supplier-user.interface';
import { CurrentShijiUserInterface } from '../interfaces/current-shiji-user.interface';
import { BasePermissionsFunctions } from '../abstract/base-permissions-functions';
import get from 'lodash-es/get';

@Directive({
    selector: '[appPermission]',
    standalone: true,
})
export class PermissionDirective extends BasePermissionsFunctions implements OnDestroy {
    @Input() set appPermission(value: string) {
        this._appPermission = value;
        this.computeDisplay();
    }

    get appPermission(): string {
        return this._appPermission;
    }

    private _appPermission!: string;
    private subscriptions: { [key: string]: Subscription } = {};

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionsService: PermissionsService,
    ) {
        super();
    }

    public ngOnDestroy(): void {
        unsubscribeFromAll(this.subscriptions);
    }

    private computeDisplay() {
        this.viewContainer.clear();

        if (!this.appPermission) {
            return;
        }

        if (this.appPermission === 'appPermissionAlwaysShow') {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }

        if (this.subscriptions.permissions) {
            this.subscriptions.permissions.unsubscribe();
            delete this.subscriptions.permissions;
        }

        this.subscriptions.permissions = this.permissionsService
            .getPermissions()
            .subscribe(([permissionLabelsObject, currentUser, resources]) => {
                this.viewContainer.clear();
                const permissionObject: PermissionObject = get(permissionLabelsObject, this.appPermission);

                if (permissionLabelsObject && permissionObject) {
                    if (!this.isCurrentUserAShijiUser(currentUser)) {
                        currentUser = this.enrichUserResourcePermissionsObject(currentUser, resources);
                    }

                    this.handleDisplay(permissionObject, currentUser);
                }
            });
    }

    private handleDisplay(permissionObject: PermissionObject, currentUser: CurrentSupplierUserInterface | CurrentShijiUserInterface) {
        if (this.hasAccess(currentUser, permissionObject)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        } else {
            this.viewContainer.clear();
            return;
        }
    }
}
